export default __webpack_public_path__ + "static/media/plus.8aa4d504.svg";